const { formatMoney, translateString } = window.BAO.Utils

class StackSetForm extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['product']
  }

  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  setupListeners () {
    super.setupListeners()

    this.log('Config', this.config)

    this.externalEls.product.elements.forEach(product => {
      this.listeners.add(product, 'change', event => this.render(event))
    })

    this.listeners.add(this.els.form.element, 'submit', event =>
      this.handleFormSubmit(event),
    )
  }

  /** @param {SubmitEvent} event */
  handleFormSubmit (event) {
    event.preventDefault()

    this.addItemsToCart()
  }

  addItemsToCart () {
    window.BAO.Cart.addItem(this.buildItems())
  }

  buildItems () {
    const stackingId = Date.now().toString()

    const items = this.selectedProducts.flatMap(product => {
      const items = [
        {
          id: product.value.toString(),
          quantity: 1,
          properties: {
            _stacking_id: stackingId,
            _stacking_discount: this.config.discountAmount,
            _stacking_minimum_products: this.config.minimumAmountOfProducts,
            _purchased_from: this.dataset.purchasedFromMessage,
          },
        },
      ]

      if (product.hasGifting) {
        return window.BAO.Gifting.generateGiftingItems(
          window.BAO.Gifting.getUniqueId(),
          items,
          product.giftingBar,
        )
      }

      return items
    })

    this.log('buildItems', { items })

    return items
  }

  render () {
    this.renderSubmitButtons()
    this.renderCounters()
    this.renderPrices()
  }

  renderSubmitButtons () {
    const totalSelectedProducts = this.selectedProducts.length

    const buttons = [this.els.submit.element]
    if (this.externalEls.submit) {
      buttons.push(...this.externalEls.submit.elements)
    }

    buttons.forEach(button => {
      button.disabled = totalSelectedProducts === 0
    })

    let buttonTextTemplate = this.dataset.submitTextNoItemsTemplate
    if (totalSelectedProducts > 1) {
      buttonTextTemplate = this.dataset.submitTextWithItemsPluralTemplate
    } else if (totalSelectedProducts === 1) {
      buttonTextTemplate = this.dataset.submitTextWithItemsSingularTemplate
    }

    const textEls = [this.els['submit-text'].element]
    if (this.externalEls['submit-text']) {
      textEls.push(...this.externalEls['submit-text'].elements)
    }

    textEls.forEach(textEl => {
      textEl.textContent = translateString(buttonTextTemplate, {
        count: totalSelectedProducts,
        price: formatMoney(
          this.discountShouldBeApplied
            ? this.totalCost * this.config.discountAmount
            : this.totalCost,
        ),
      })
    })
  }

  renderCounters () {
    if (!this.externalEls.counter) {
      return
    }

    this.externalEls.counter.elements.forEach(counter => {
      const { messageTemplate } = counter.dataset

      counter.textContent = translateString(messageTemplate, {
        total: this.selectedProducts.length,
      })
    })
  }

  renderPrices () {
    this.externalEls.product.elements.forEach(product => {
      const compareAtPrice = product.els['compare-price'].element
      const price = product.els.price.element

      compareAtPrice.hidden = !this.discountShouldBeApplied
      compareAtPrice.textContent = formatMoney(product.variant.price)

      const multiplier = this.discountShouldBeApplied
        ? this.config.discountAmount
        : 1

      price.textContent = formatMoney(product.variant.price * multiplier)
    })

    if (!this.externalEls.price) {
      return
    }

    const totalPrice = formatMoney(this.totalCost)

    this.externalEls.price.elements.forEach(element => {
      element.textContent = totalPrice
    })
  }

  get selectedProducts () {
    return this.externalEls.product.elements.filter(product => product.checked)
  }

  get totalCost () {
    return this.selectedProducts.reduce(
      (sum, product) => sum + product.variant.price,
      0,
    )
  }

  get config () {
    const discountAmount = (() => {
      const amount = (Number(this.dataset.discountAmount) || 0) / 100

      if (amount < 0) return 0
      if (amount > 1.0) return 1.0

      return 1.0 - amount
    })()
    const minimumAmountOfProducts = this.dataset.mininumAmountOfProducts
      ? Number(this.dataset.mininumAmountOfProducts)
      : null

    return {
      discountAmount,
      minimumAmountOfProducts,
      discountCanBeApplied:
        minimumAmountOfProducts != null && discountAmount > 0,
    }
  }

  get discountShouldBeApplied () {
    return (
      this.config.discountCanBeApplied &&
      this.selectedProducts.length >= this.config.minimumAmountOfProducts
    )
  }
}

if (!customElements.get('stack-set-form')) {
  customElements.define('stack-set-form', StackSetForm)
}
